import * as Yup from 'yup';

const errorMessage = 'Vous devez sélectionner un tiers';

export const ThirdPartySelectSchema = Yup.object().shape({
  thirdPartyId: Yup.string().required(errorMessage),
});
